import { AccountMovementDataEntity } from '../../core/entities/bank/account-movement-data.entity';
import { AccountTableEntity } from '../../core/entities/bank/account-table.entity';
import { AccountsTableResponse } from '../interfaces/accounts-table.interface';

export class AccountTableMapper {
  static fromResponseToEntity(
    response: AccountsTableResponse
  ): AccountTableEntity {
    return new AccountTableEntity(
      response.page,
      response.totalPages,
      response.data.map(
        (item) =>
          new AccountMovementDataEntity(
            item.accountType,
            item.accountName,
            item.accountNumber,
            item.balance
          )
      )
    );
  }
}
